import { CanDeactivateFn } from '@angular/router';

export interface CanDeactivate {
    canDeactivate: () => Promise<boolean>;
}

export const canDeactivateGaurd: CanDeactivateFn<CanDeactivate> = (component: CanDeactivate) => {
    return component.canDeactivate();
};
